import { atom } from 'jotai';

interface StepAtomParams {
  /** The initial step of the atom. */
  initial: number;
  /** The minimum step of the atom. */
  min?: number;
  /** The maximum step of the atom. */
  max?: number;
}

/**
 * This is a utility that creates an atom that can be incremented, decremented, reset, or set to an arbitrary value.
 */
export function stepAtom({ initial, min = 1, max = Infinity }: StepAtomParams) {
  const internalAtom = atom(initial);

  return atom(
    (get) => get(internalAtom),
    (get, set, action: 'increment' | 'decrement' | 'reset' | number) => {
      if (action === 'increment') {
        set(internalAtom, Math.min(max, get(internalAtom) + 1));
      }
      if (action === 'decrement') {
        set(internalAtom, Math.max(min, get(internalAtom) - 1));
      }

      if (action === 'reset') {
        set(internalAtom, initial);
      }

      if (typeof action === 'number') {
        set(internalAtom, action);
      }
    }
  );
}
